export default __webpack_public_path__ + "static/media/stacja_zlewna.fefb0573.png";